import {useState} from "react";
import SupportWidgetPreview from "../../../assets/images/support-widget-preview.jpg";

const SupportWidget = ({ onEdit }: { onEdit: () => void }) => {
    return (
        <div className='widget support-widget' onClick={onEdit}>
            <div className="top">
                <div className="left">
                    <img alt="Support Widget" src={SupportWidgetPreview} width={250} height={250} />
                </div>
                <div className="right">
                    <div className="top">
                        <div className="title">Support Widget</div>
                        <div className="subtitle">
                            The Vuelve Support Widget lets customers chat with your store directly from your website, either inside the widget or via WhatsApp. You can display up to 3 predefined Q&A options in a chat-like experience, choose whether users must register with their name and phone number before chatting, or allow instant access. The widget is fully customizable—colors, texts, and languages.
                        </div>
                    </div>
                    <div className="bottom">
                        <span onClick={onEdit}>Edit Support Widget</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SupportWidget;